import * as React from 'react';
import {ReactNode} from 'react';
import style from './index.module.scss';

interface IProgressProps extends React.HTMLAttributes<HTMLDivElement> {
    small?: boolean;
    message?: ReactNode;
}

export const Progress = ({small, className, message, ...otherProps}: IProgressProps) => <div className={style.progress}>
    <div {...otherProps} className={[style.progress, style.progressDots, small && style.small, className].join(' ')}>
        <div className={style.dot1}/>
        <div className={style.dot2}/>
        <div/>
    </div>
    {message && <div className={style.message}>{message}</div>}
</div>;

